import MultiSelectDropdown from "../dropdowns/multiSelectDropdown";
import { ManifestResponse } from "../../apiClient";
import useApiClient from "../../hooks/useApiClient";
import {useState} from "react";
import {useDebouncedFunction} from "../../hooks/useDebouncedQueryParams";
import {DEBOUNCE_DELAY} from "../../utils";
import {useQuery} from "@tanstack/react-query";
import {MultiSelectDropdownSmartWrapperProps} from "../dropdowns/types";
import {QUERY_OPTIONS_LOAD_ONCE} from "../../apiUtils";

export const ManifestDropdown = (dropdownProps: MultiSelectDropdownSmartWrapperProps<ManifestResponse, string>) => {
    const api = useApiClient();
    const [debouncedSearchTerm, _setDebounceSearchTerm] = useState("");
    const setDebounceSearchTerm = useDebouncedFunction(
        _setDebounceSearchTerm,
      DEBOUNCE_DELAY
    );

    const { data: manifestsData, isLoading: isLoadingManifests } = useQuery({
      queryKey: ["manifests"],
      queryFn: () => api.dataTransfer.listManifests({}),
      ...QUERY_OPTIONS_LOAD_ONCE,
    });

    const filteredData = debouncedSearchTerm ? manifestsData?.filter(m => m.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())) : manifestsData
    return (
        <MultiSelectDropdown<ManifestResponse, string>
            label={"Manifests"}
            options={filteredData ?? []}
            selections={[]}
            isLoading={dropdownProps.isLoading || isLoadingManifests}
            renderOption={(o) => o.name}
            onSearchTermChange={setDebounceSearchTerm}
            mapOptionToSelection={o => o.public_id ?? ""}
            {...dropdownProps}
        />
    )
}

export default ManifestDropdown